'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    NachwuchsfoerderungResource = _require2.NachwuchsfoerderungResource;

module.exports.Nachwuchsfoerderung = function (_BaseEntity) {
  _inherits(Nachwuchsfoerderung, _BaseEntity);

  _createClass(Nachwuchsfoerderung, null, [{
    key: '__name__',
    value: function __name__() {
      return 'nachwuchsfoerderung';
    }
  }]);

  function Nachwuchsfoerderung(data) {
    _classCallCheck(this, Nachwuchsfoerderung);

    var _this = _possibleConstructorReturn(this, (Nachwuchsfoerderung.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung)).call(this));

    _this._entityName = 'de.ul.fob.domain.Nachwuchsfoerderung';
    _this.abgeschlossen = false;
    _this.beginn = null;
    _this.inForschungsprojekt = null;
    _this.inPromotionsprogramm = null;
    _this.istFinal = false;
    _this.kooperation = null;
    _this.nachwuchsfoerderungsTyp = null;
    _this.pruefungsdatum = null;
    _this.titel = null;

    _this.erstbetreuer = null;
    _this.forschungsprojekt = null;
    _this.organisationseinheit = null;
    _this.promotand = null;
    _this.strukturiertesPromotionsprogramm = null;
    _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Nachwuchsfoerderung, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'abgeschlossen', 'beginn', 'inForschungsprojekt', 'inPromotionsprogramm', 'istFinal', 'kooperation', 'nachwuchsfoerderungsTyp', 'pruefungsdatum', 'titel'],
        links: ['erstbetreuer', 'forschungsprojekt', 'organisationseinheit', 'promotand', 'strukturiertesPromotionsprogramm']
      });
    }
  }, {
    key: 'fetchErstbetreuer',
    value: function fetchErstbetreuer() {
      return _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'erstbetreuer');
    }
  }, {
    key: 'fetchForschungsprojekt',
    value: function fetchForschungsprojekt() {
      return _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'forschungsprojekt');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchPromotand',
    value: function fetchPromotand() {
      return _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'promotand');
    }
  }, {
    key: 'fetchStrukturiertesPromotionsprogramm',
    value: function fetchStrukturiertesPromotionsprogramm() {
      return _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'strukturiertesPromotionsprogramm');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'erstbetreuer'), _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'forschungsprojekt'), _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'promotand'), _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'genericResolve', this).call(this, 'strukturiertesPromotionsprogramm')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof NachwuchsfoerderungResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Nachwuchsfoerderung.prototype.__proto__ || Object.getPrototypeOf(Nachwuchsfoerderung.prototype), 'fetchQuery', this).call(this, NachwuchsfoerderungResource);
      }
    }
  }]);

  return Nachwuchsfoerderung;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/nachwuchsfoerderung.js
// module id = 7rrg
// module chunks = 0